import React, { Component } from "react";
import { MutationFn } from "react-apollo";
import { translate } from "react-polyglot";
import { ClipLoader } from "react-spinners";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Subscribe } from "unstated";
import {
  GeneratePdfComponent,
  GeneratePdfMutation,
  GeneratePdfMutationVariables
} from "../../generated/graphql";
import FilterState from "../../state/FilterState";
import isRevitClient from "../../helpers/isRevitClient";
import { openPdf } from "../../helpers/revitClient";

interface IProps {
  buildupId: string;
}

interface IState {
  isModalOpen: boolean;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
}

const initialData: IState = {
  isError: false,
  isLoading: false,
  isModalOpen: false,
  isSuccess: false
};

interface IFilter {
  id: string;
  allowedValues?: any[] | object;
  parameter: string;
  operator: string;
  values: string[];
  isPrimary: boolean;
}

class GeneratePDFButton extends Component<IProps & TranslateProps, IState> {
  constructor(props: IProps & TranslateProps) {
    super(props);
    this.state = initialData;
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleGeneratePDF = this.handleGeneratePDF.bind(this);
  }

  public render() {
    const { isModalOpen, isError, isLoading, isSuccess } = this.state;
    const { buildupId, t } = this.props;
    return (
      <Subscribe to={[FilterState]}>
        {(filterState: any) => {
          const {
            state: { filters }
          } = filterState;
          const mappedFilters = filters.map((f: IFilter) => {
            const { id, parameter, operator, values } = f;
            return {
              id,
              operator,
              parameter,
              values
            };
          });
          return (
            <React.Fragment>
              <GeneratePdfComponent>
                {generatePDFMutation => (
                  <Button
                    onClick={() =>
                      this.handleGeneratePDF(
                        generatePDFMutation,
                        buildupId,
                        mappedFilters
                      )
                    }
                    color="success"
                  >
                    {t("labels.generatePDF")}
                  </Button>
                )}
              </GeneratePdfComponent>
              <Modal
                isOpen={isModalOpen}
                size="sm"
                toggle={() => this.handleModalClose()}
              >
                <ModalHeader>{t("labels.generatePDF")}</ModalHeader>
                <ModalBody>
                  {isLoading && (
                    <React.Fragment>
                      {t("labels.pdfLoading")}
                      <div className="d-flex justify-content-center align-content-center pt-5">
                        <ClipLoader
                          loading={isLoading}
                          size={150}
                          sizeUnit="px"
                          color="#0077ab"
                        />
                      </div>
                    </React.Fragment>
                  )}
                  {isError && t("errors.pdfFailed")}
                  {isSuccess && t("labels.pdfSuccess")}
                </ModalBody>
                <ModalFooter>
                  {isError || isSuccess ? (
                    <Button onClick={() => this.handleModalClose()}>
                      {t("labels.close")}
                    </Button>
                  ) : null}
                </ModalFooter>
              </Modal>
            </React.Fragment>
          );
        }}
      </Subscribe>
    );
  }

  private handleModalClose() {
    this.setState({
      isError: false,
      isLoading: false,
      isModalOpen: false,
      isSuccess: false
    });
  }

  private handleGeneratePDF(
    mutation: MutationFn<GeneratePdfMutation, GeneratePdfMutationVariables>,
    buildupId: string,
    filters: any
  ) {
    this.setState({ isModalOpen: true, isLoading: true, isError: false });
    mutation({
      variables: { input: { buildupId, filters } }
    })
      .then(response => {
        if (!response) {
          return;
        }
        const {
          data: {
            generatePDF: { location }
          }
        } = response;

        if (isRevitClient()) {
          openPdf(location);
        } else {
          window.open(location, "_blank");
        }
        this.setState({ isLoading: false, isSuccess: true });
      })
      .catch(() => {
        this.setState({ isError: true, isLoading: false });
      });
  }
}

export default translate()(GeneratePDFButton);
